<div class="container-fluid mt-4">
  <h4 class="mb-3"> <i class="fi fi-rr-brand"></i> ბრენდები </h4>
    
      <div>
        <button type="button" class="btn btn-primary" (click)="add()">დამატება</button>
      </div>
    <div class="row g-4">

      <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>
      
      <app-error  *ngIf="!load && error" [title]="'შეცდომა ჩატვირთვის დროს'" (reload)="get()"></app-error>

      <div class="position-relative">

        <div *ngIf="!load" cdkDropList (cdkDropListDropped)="drop($event)">
          <div *ngFor="let item of data" cdkDrag class="card p-2 mb-2 shadow-sm">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <img src="{{url}}/marks/{{item.image}}">
                <span class="mx-1"> {{item.name}}</span>
              </div>
              <div class="d-flex">
                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="edit(item)"><i class="fi fi-rr-pencil"></i></button> 
                <button class="btn btn-sm text-danger border rounded d-flex align-items-center mx-2" (click)="destroy(item)"><i class="fi fi-rr-trash"></i></button> 
              </div>
            </div>
          </div>
        </div>

        
        <div class="load-blur" *ngIf="loadUpdate">
          <app-spinner [loading]="loadUpdate" text="იტვირთება..."></app-spinner>
        </div>
      </div>


    </div>
</div>

<ng-template #formModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <span *ngIf="isEdit">რედაქტირება</span>
      <span *ngIf="!isEdit">დამატება</span>
      <span> ბრენდის </span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
      <form [formGroup]="form">
        
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="name"
              id="name"
              placeholder=""
              required>
            <label for="name">დასახელება</label>
            <div class="invalid-feedback">
              error
            </div>
          </div>

          <img *ngIf="form.get('image').value" src="{{url}}/marks/{{form.get('image').value}}">

          <div class="form-floating mt-3">
              <app-upload
              [uploadPath]="'marks'"
              (fileUploaded)="onFileUploaded($event)"
             >
            </app-upload>   
          </div>
     


      </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
    <button class="btn btn-primary d-flex" (click)="save(modal)" [disabled]="editBtnLoad">
      <app-spinner [sm]="true" [loading]="editBtnLoad"></app-spinner> 
      <span *ngIf="isEdit">შენახვა</span>
      <span *ngIf="!isEdit">დამატება</span>
    </button>
  </div>
</ng-template>
